import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { CloseDealModalContentWrapper } from './styled'
import FormSelectShared from '../FormSelectShared'

import { endpoints } from 'modules/endpoints'
import { SharedModalContent } from '../SharedModal'
import { FormikFieldsType } from 'modules/domain/types'
import { FormRadio } from '../form/FormRadio'
import { RadioItem, Text } from '@agro-club/agroclub-shared'
import { Card } from '../Card/Card'
import { SampleWithRequests, SamplesProgressStatuses } from 'views/pages/Samples/types'

interface Props {
  formik: FormikFieldsType
  value: string
  samplesData?: SampleWithRequests[]
}

export const CloseDealModalContent: FC<Props> = ({ formik, value, samplesData }) => {
  const { t } = useTranslation('deal')

  let hasSampleRequestInProgress = false
  if (samplesData?.[0]?.sample_requests?.[0]) {
    const status = samplesData[0].sample_requests[0].status
    if (![SamplesProgressStatuses.CANCELED, SamplesProgressStatuses.COMPLETED].includes(status)) {
      hasSampleRequestInProgress = true
    }
  }

  return (
    <SharedModalContent>
      <CloseDealModalContentWrapper>
        {hasSampleRequestInProgress && (
          <Card.Container intent="warning">
            <Text as="span" typography="accentLarge" color="primary">
              {t('dealHasSamples')}
            </Text>
            <FormRadio formik={formik} field="cancel_sample_request" labelHeight="small">
              <RadioItem value={false} label={t('continueSample')} />
              <RadioItem value={true} label={t('cancelSample')} />
            </FormRadio>
          </Card.Container>
        )}
        {t('closeDealModal.text')}
        <FormSelectShared
          formik={formik}
          endpoint={endpoints.dealsCloseReasons()}
          fieldName={value}
          simpleApiFormat
          showSearch={false}
          getLabel={(dto) => dto.label}
          hideLabel
          disableRightPadding
          allowClear={false}
        />
      </CloseDealModalContentWrapper>
    </SharedModalContent>
  )
}
